import { styled } from '@mui/material/styles';
import { Button as BaseButton } from 'components/buttons';

export const Button = styled(BaseButton)(({ disabledColor }) => ({
  '&:disabled, &[disabled]': {
    background: disabledColor || '#F5F5F5',
    color: disabledColor ? 'white' : '#CCCCCC',
    '&:hover': {
      background: disabledColor || '#F5F5F5',
      color: disabledColor ? 'white' : '#CCCCCC'
    }
  }
}));

export const FlexContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between'
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  margin: theme.spacing(-1.5),
  width: `calc(100% + ${theme.spacing(3)})`,
  [`& ${Button}`]: {
    margin: theme.spacing(1.5),
    '@media (max-width: 400px)': {
      flex: '1 1 100%'
    }
  }
}));

export const Explain = styled('div')(({ theme }) => ({
  fontSize: theme.fontSize.normal,
  fontWeight: theme.fontWeight.bold,
  margin: theme.spacing(1.5, 0, 0, 1.5)
}));

export const FormRowContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: '100%',
  flexDirection: 'column',
  marginBottom: theme.spacing(5)
}));

export const Section = styled('div')(({ $wrap, $justify }) => ({
  display: 'flex',
  flexGrow: 1,
  flexWrap: $wrap || 'wrap',
  ...($justify && { justifyContent: $justify }),
  '@media (max-width: 650px)': {
    justifyContent: 'center'
  }
}));
